module.exports = __webpack_public_path__ + "static/55-8cbad95a1ecbd031650e0d0e25692aa6.png";